import { alpha } from '@mui/material/styles';

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
          paddingInline: theme.spacing(2),
          transition: 'background-color .15s ease, color .15s ease, border-color .15s ease',
          '&:hover': { boxShadow: 'none' },
        },
        sizeSmall: { height: 32, fontSize: theme.typography.pxToRem(13) },
        sizeMedium: { height: 38 },
        sizeLarge: { height: 44, fontSize: theme.typography.pxToRem(15) },
        containedInherit: {
          color: theme.palette.grey[900],
          backgroundColor: theme.palette.grey[100],
          '&:hover': { backgroundColor: theme.palette.grey[200] },
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': { backgroundColor: theme.palette.primary.dark, boxShadow: 'none' },
        },
        containedSecondary: { boxShadow: 'none' },
        outlined: {
          borderColor: theme.palette.grey[300],
          '&:hover': {
            backgroundColor: theme.palette.grey[100],
            borderColor: theme.palette.grey[400],
          },
        },
        outlinedInherit: {
          color: theme.palette.grey[800],
          border: `1px solid ${theme.palette.grey[300]}`,
          '&:hover': {
            backgroundColor: theme.palette.grey[100],
            borderColor: theme.palette.grey[400],
          },
        },
        outlinedPrimary: {
          borderColor: alpha(theme.palette.primary.main, 0.4),
          '&:hover': {
            backgroundColor: theme.palette.primary.lighter,
            borderColor: theme.palette.primary.main,
          },
        },
        text: {
          '&:hover': { backgroundColor: theme.palette.grey[100] },
        },
        textInherit: {
          '&:hover': { backgroundColor: theme.palette.action.hover },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          transition: 'background-color .15s ease',
        },
      },
    },
  };
}
